import { Component, Input } from "@angular/core";

@Component({
    selector: "material-tile",
    templateUrl: "./material-tile.component.html",
    styleUrls: ["./material-tile.component.scss"],
})
export class MaterialTileComponent {
    @Input() stat: any;
    @Input() label: string;
    @Input() isContentCenterAligned: boolean = true;
}
